import type { Survey, SurveyResponse } from '@doneverse/shared'
import { api } from '../api/index.js'

export interface SubmitSurveyResponseRequest {
  score: number
  comment?: string
}

export const surveyService = {
  /** Active surveys the caller still needs to answer this week (NPS first). */
  fetchDueSurveys: async (): Promise<{ surveys: Survey[] }> => {
    return api.get('/v1/surveys/due').json<{ surveys: Survey[] }>()
  },

  /** Submit a 0–10 response (with optional comment) to a survey. */
  submitResponse: async (surveyId: string, data: SubmitSurveyResponseRequest): Promise<SurveyResponse> => {
    return api.post(data, `/v1/surveys/${surveyId}/responses`).json<SurveyResponse>()
  },
}
